/**
 * Welche Treffer die Auswahlsuche zeigt.
 *
 * Höchstens vier, weil darüber niemand mehr liest, sondern danebengreift. Zwei
 * Ausnahmen sind nötig, seit mehrere Einträge denselben Namen tragen dürfen
 * (HJ-042), denn sonst ist etwas gar nicht zu erreichen oder wird doppelt angelegt:
 *
 * Wortgleiche stehen vorn und sind ALLE zu sehen. Hinter vier ähnlichen verschwand
 * ein exakter Name, und „Ist neu – anlegen" erzeugte die Dublette, gegen die der
 * Hinweis gedacht ist.
 *
 * Gesucht wird auch in der Anschrift: „Korn 89073" trifft den einen Standort. Was
 * danach noch nicht passt, wird gezählt (`weitere`), damit niemand glaubt, die Liste
 * sei vollständig.
 *
 * Eigene Datei ohne Supabase, damit `npm run logik` sie prüfen kann.
 */

import { normalisiert, passt } from './textvergleich.ts';

type Eintrag = { name: string; unter?: string | null };

export function trefferWaehlen<T extends Eintrag>(
  auswahl: T[],
  suche: string,
  hoechstens: number,
): { treffer: T[]; weitere: number } {
  if (!suche.trim()) return { treffer: auswahl.slice(0, hoechstens), weitere: 0 };

  const gesucht = normalisiert(suche);
  const wortgleich: T[] = [];
  const imNamen: T[] = [];
  const inAnschrift: T[] = [];
  for (const eintrag of auswahl) {
    if (normalisiert(eintrag.name) === gesucht) wortgleich.push(eintrag);
    else if (passt(eintrag.name, suche)) imNamen.push(eintrag);
    else if (eintrag.unter && passt(`${eintrag.name} ${eintrag.unter}`, suche)) inAnschrift.push(eintrag);
  }

  const uebrige = [...imNamen, ...inAnschrift];
  const platz = Math.max(0, hoechstens - wortgleich.length);
  return {
    treffer: [...wortgleich, ...uebrige.slice(0, platz)],
    weitere: Math.max(0, uebrige.length - platz),
  };
}
